import { atom } from 'jotai';

const isSearchOpenAtom = atom(false);

export default isSearchOpenAtom;
